module.exports = __webpack_public_path__ + "img/title2.5cde06a2.png";